export default {
  message: "消息",
  toConfirmed: "待对方确认",
  to: "待",
  confirmed: "确认",
  toConfirmed2: "待您确认",
  employe: '员工',
  highMatching: "高匹配度",
  mediumMatching: "中匹配度",
  lowMatching: "低匹配度",
  details: "详情",
  assignEmployees: "分配员工",
  employeeSearch: "输入员工姓名搜索"
}